export default {"id":"dd1a400a","attrs":{"viewBox":"0 0 20 20","width":"20","height":"20"}}